import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@workspace/ui/components/select";

export function SelectControl({
	value,
	onChange,
	options,
	label,
	className = "",
	disabled = false,
}: {
	value: string;
	onChange: (value: string) => void;
	options: { value: string; label: string }[];
	label: string;
	className?: string;
	disabled?: boolean;
}) {
	return (
		<Select
			disabled={disabled}
			items={options}
			value={value}
			onValueChange={(next) => onChange(next ?? "")}
		>
			<SelectTrigger
				aria-label={label}
				className={`h-9 min-w-36 max-w-full ${className}`}
			>
				<SelectValue />
			</SelectTrigger>
			<SelectContent
				align="start"
				alignItemWithTrigger={false}
				className="max-h-72 max-w-[calc(100vw-2rem)] bg-background"
			>
				{options.map((option) => (
					<SelectItem key={option.value} value={option.value}>
						{option.label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}
